<template>
  <v-card>
    <v-toolbar dark prominent src="https://picsum.photos/1920/1080?random">
      <v-toolbar-title>Master Schedule </v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-spacer />
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          offset-x
          min-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Picker in menu"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="
                menu = false;
                date = scheduleDate;
              "
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                menu = false;
                scheduleDate = date;
              "
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-btn depressed class="mx-3" color="primary" @click="goToday()">
          Go Today
        </v-btn>

        <div max-width="300">
          <v-select
            v-if="$store.state.u.location_id == 6"
            class="mt-6"
            v-model="location_id"
            :items="locations"
            item-text="name"
            item-value="id"
            label="Locations"
            dense
            dark
          ></v-select>
        </div>
      </template>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-simple-table fixed-header text-justify height="800px">
          <template v-slot:default>
            <thead color="primary">
              <tr>
                <th></th>
                <th v-for="period in periods" :key="period.id">
                  <div class="text-center">
                    <h2>Period {{ period.name }}</h2>
                    {{ usTime(period.start_time) }}<br />{{
                      usTime(period.end_time)
                    }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="teacher in teachers" :key="teacher.id">
                <td>
                  <v-card color="primary" dark>
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-card-title v-text="teacher.id"></v-card-title>

                        <v-card-subtitle v-text="teacher.full_name">
                        </v-card-subtitle>

                        <v-card-subtitle v-text="teacher.title">
                        </v-card-subtitle>

                        <v-card-actions class="pb-0 pl-0">
                          <v-btn
                            class="mr-3"
                            icon
                            @click="showSchedule(teacher)"
                          >
                            <v-icon>mdi-calendar-clock</v-icon>
                          </v-btn>
                          <span
                            v-if="zoom.find((z) => z.user_id == teacher.id)"
                          >
                            <a
                              v-if="
                                zoom.find((z) => z.user_id == teacher.id).pmi >
                                0
                              "
                              :href="
                                zoom.find((z) => z.user_id == teacher.id)
                                  .join_url
                              "
                              target="_blank"
                              style="text-decoration: none"
                            >
                              <v-chip color="white" class="pa-1">
                                <v-icon color="blue darken-2" class="ma-0">
                                  mdi-video
                                </v-icon>
                              </v-chip>
                            </a>
                            <v-tooltip v-else right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  color="white"
                                  class="pa-1"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon color="orange darken-2" class="ma-0">
                                    mdi-video-off
                                  </v-icon>
                                </v-chip>
                              </template>
                              <span
                                >Teacher should login to zoom once and start a
                                meeting with "Personal Meeting Room"</span
                              >
                            </v-tooltip>
                          </span>
                          <v-tooltip v-else right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                color="white"
                                class="pa-1"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="red darken-2" class="ma-0">
                                  mdi-video-minus
                                </v-icon>
                              </v-chip>
                            </template>
                            <span>Zoom account is not found</span>
                          </v-tooltip>
                          <!--                             <v-btn
                              class="ml-2 mt-0 mb-0"
                              fab
                              icon
                              height="40px"
                              right
                              width="40px"
                            >
                              <v-icon>mdi-information</v-icon>
                            </v-btn> -->
                          <v-btn
                            class="ml-3"
                            icon
                            @click="assignSubstitute(teacher)"
                          >
                            <v-icon>mdi-account-convert</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </div>

                      <v-avatar class="ma-3" size="150" tile>
                        <v-img></v-img>
                      </v-avatar>
                    </div>
                  </v-card>
                </td>

                <td v-for="period in periods" :key="period.id">
                  <v-card
                    dark
                    v-if="schedules[teacher.id][period.name]"
                    :color="
                      schedules[teacher.id][period.name].user_type ==
                      'Primary Teacher'
                        ? 'primary'
                        : 'secondary'
                    "
                  >
                    <v-card-text class="text-center">
                      {{ schedules[teacher.id][period.name].course_name }}
                      <br />
                      Section:
                      {{ schedules[teacher.id][period.name].section }}
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions class="pb-0 pl-0 pt-0">
                      <v-progress-circular
                        v-if="loading == `${teacher.id}-${period.name}`"
                        :size="20"
                        color="white"
                        class="ml-1"
                        indeterminate
                      ></v-progress-circular>
                      <v-btn
                        v-else
                        class="ml-1 mt-0"
                        fab
                        icon
                        height="40px"
                        right
                        width="40px"
                        dark
                        :color="
                          getContentId(schedules[teacher.id][period.name]) > 0
                            ? 'green'
                            : 'orange'
                        "
                        @click="viewContent(schedules[teacher.id][period.name])"
                      >
                        <v-icon>mdi-text-box</v-icon>
                      </v-btn>
                      <v-btn
                        class="ml-1 mt-0"
                        fab
                        icon
                        height="40px"
                        right
                        width="40px"
                        dark
                        @click="evaluateTeacher(period, teacher)"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                      <v-btn
                        class="ml-1 mt-0"
                        fab
                        icon
                        height="40px"
                        right
                        width="40px"
                        dark
                        :color="
                          isSubstituteAssigned(period, teacher)
                            ? 'yellow'
                            : 'white'
                        "
                        @click="assignSubstitute(teacher, period)"
                      >
                        <v-icon>mdi-account-convert</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          google_classroom.findIndex(
                            (g) =>
                              g.section ==
                                schedules[teacher.id][period.name].section &&
                              g.course_id ==
                                schedules[teacher.id][period.name].course_id
                          ) > -1
                        "
                        small
                        class="ml-2"
                        icon
                        :href="
                          google_classroom.find(
                            (g) =>
                              g.section ==
                                schedules[teacher.id][period.name].section &&
                              g.course_id ==
                                schedules[teacher.id][period.name].course_id
                          ).link
                        "
                        target="_blank"
                      >
                        <v-icon small color="white" class="ma-0">
                          mdi-google-classroom
                        </v-icon>
                      </v-btn>
                      <v-btn small class="ml-2" icon v-else>
                        <v-icon small color="red" class="ma-0">
                          mdi-google-classroom
                        </v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="sDialog" width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Assign Substitute
        </v-card-title>
        <v-card-text>
          <treeselect
            placeholder="Select a Staff"
            class="mt-4"
            v-model="substitute.user_id"
            :max-height="180"
            :disable-branch-nodes="true"
            :clear-on-select="true"
            :options="teachersList"
          ></treeselect>
        </v-card-text>
        <v-card-text v-if="cautionText.length > 0">
          {{ cautionText }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="sDialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="substituteSave">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eDialog" width="600">
      <v-card height="350px">
        <v-card-title class="headline grey lighten-2">
          Evaluate Teacher
        </v-card-title>

        <v-card-text>
          <v-card height="224px" class="pt-4">
            <p>Coming Soon</p>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="eDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cDialog" width="600">
      <div v-if="courseContents.length > 0">
        <div
          class="text-center"
          v-for="courseContent in courseContents"
          :key="courseContent.id"
        >
          <v-container fluid>
            <v-card max-width="900" class="mx-auto">
              <v-toolbar class="headline grey lighten-2">
                Lesson Plan
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text class="mt-5">
                <v-row>
                  <v-container fluid>
                    <v-card outlined>
                      <v-toolbar dark dense>Lesson Plan Header</v-toolbar>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12" md="12" lg="12" class="text-h5 pa-0">
                            Title: {{ courseContent.title }}
                          </v-col>
                          <v-col cols="12" md="12" lg="12" class="py-0">
                            Unit:
                            {{
                              courseContent.unit
                                ? courseContent.unit.objective
                                : ""
                            }}
                          </v-col>

                          <v-col cols="12" md="12" lg="12" class="py-0">
                            Learning Objective/Essential Question:
                            {{ courseContent.essential_question }}
                          </v-col>

                          <v-col cols="12" md="12" lg="12" class="py-0">
                            Learning Standards:
                            <v-list dense>
                              <v-list-item
                                dense
                                v-for="standard in courseContent.standards"
                                :key="standard.phaseRank"
                              >
                                {{ standard.objective }}
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-container>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <v-card outlined>
                      <v-toolbar dark dense>Lesson Plan Content</v-toolbar>

                      <v-col
                        v-for="(content, id) in courseContent.contents"
                        :key="id"
                        cols="12"
                        md="12"
                        lg="12"
                      >
                        <v-card outlined>
                          <v-toolbar color="grey lighten-2" dense>
                            <v-toolbar-title>
                              {{ content.type ? content.type : "Untitled" }}
                            </v-toolbar-title>
                          </v-toolbar>
                          <v-card-text v-html="content.content"></v-card-text>
                        </v-card>
                      </v-col>
                    </v-card>
                  </v-container>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </div>
      </div>
      <div class="text-center" v-else>
        <v-container fluid>
          <v-card max-width="900" class="mx-auto">
            <v-toolbar class="grey lighten-2">
              Lesson Plan is not found
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-container>
      </div>
    </v-dialog>
    <v-dialog v-model="loading" width="600">
      <v-progress-circular
        indeterminate
        width="3"
        size="20"
        color="primary"
      ></v-progress-circular>
      Loading ..
    </v-dialog>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :multi-line="true">
        {{ snackbarText }}
      </v-snackbar>
    </div>
  </v-card>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  watch: {
    location_id: "getMasterSchedule",
    scheduleDate: "getMasterSchedule",
    // course: "gotoCourse",
  },
  data() {
    return {
      loading: true,
      snackbar: false,
      snackbarText: "",
      eDialog: false,
      events: [],
      teachersList: [],
      cautionText: "",
      date: null,
      menu: false,
      location_id: null, // only headquarter changes it
      scheduleOptions: {
        teachers: [],
        schedules: [],
        periods: [],
        contents: [],
        zoom: [],
      },
      scheduleDate: "",
      courseContents: [],
      cDialog: false,

      sDialog: false,
      substitute: {
        user_id: null,
        schedules: [],
      },
    };
  },
  computed: {
    locations() {
      return this.$store.state.locations;
    },
    contents() {
      return this.scheduleOptions.contents;
    },
    teachers() {
      return this.scheduleOptions.teachers;
    },
    schedules() {
      return this.scheduleOptions.schedules;
    },
    periods() {
      return this.scheduleOptions.periods;
    },
    substitutes() {
      return this.scheduleOptions.substitutes;
    },
    zoom() {
      return this.scheduleOptions.zoom;
    },
    google_classroom() {
      return this.scheduleOptions.google_classroom;
    },
  },
  methods: {
    usTime(time) {
      if (typeof time !== typeof null && typeof time !== typeof undefined) {
        const [hours, minutes] = time.split(":");
        return `${hours > 12 ? hours - 12 : hours}:${minutes} ${
          hours >= 12 ? "PM" : "AM"
        }`;
      }
    },
    getMasterSchedule() {
      this.loading = true;
      this.scheduleOptions = {};
      this.$sisApi("get", `schedules/master-dated`, {
        date: this.scheduleDate,
        location: this.location_id,
      })
        .then((response) => {
          this.scheduleOptions = response.data;
          this.date = response.data.date;
          this.scheduleDate = response.data.date;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response);
          }
        });
    },
    showSchedule(teacher) {
      this.$store.state.schedule_user = teacher;
      this.$router.push("staff-schedule-view");
    },
    goToday() {
      let today = new Date().toISOString().substr(0, 10);
      this.date = today;
      this.scheduleDate = today;
    },
    evaluateTeacher(period, teacher) {
      this.eDialog = true;
    },
    assignSubstitute(teacher, period) {
      if (period) {
        let schedule = this.schedules[teacher.id][period.name];
        this.substitute.schedules.push(schedule);
        this.cautionText = `You are about to assign a substitute to the class at ${period.name} period of ${teacher.full_name}`;

        let index = this.substitutes.findIndex(
          (s) =>
            s.period == schedule.period &&
            s.course_id == schedule.course_id &&
            s.section == schedule.section
        );
        if (index > -1) {
          // to update/delete the substitute
          this.substitute.user_id = this.substitutes[index].user_id;
          this.substitute.id = this.substitutes[index].id;
          this.cautionText = `Update or remove substitute from the class at ${period.name} period of ${teacher.full_name}`;
        }
      } else {
        this.substitute.schedules = this.schedules[teacher.id];
        this.cautionText = `You are about to assign a substitute all classes of ${teacher.full_name}`;
      }

      let tempteacherlist = this.$store.state.staffListOptions.filter(
        (item) => this.schedules[item.id] == undefined
      );
      this.teachersList = this.$store.state.staffListOptions.filter(
        (item) => this.schedules[item.id] !== undefined
      );

      this.teachersList = [
        ...this.teachersList.filter(
          (item) => this.schedules[item.id][period] === undefined
        ),
        ...tempteacherlist,
      ];
      this.sDialog = true;
    },
    isSubstituteAssigned(period, teacher) {
      let schedule = this.schedules[teacher.id][period.name];
      return this.substitutes.find(
        (s) =>
          s.period == schedule.period &&
          s.course_id == schedule.course_id &&
          s.section == schedule.section
      );
    },
    substituteSave() {
      this.substitute.date = this.scheduleDate;
      this.$sisApi("post", `schedules/substitute-save`, this.substitute)
        .then((response) => {
          let id = parseFloat(response.data);
          // delete if id is returned
          if (!isNaN(id)) {
            let index = this.substitutes.findIndex((s) => (s.id == id));
            this.scheduleOptions.substitutes.splice(index, 1);
          }
          else if (response.data.length > 0) {
            response.data.forEach((s) => {
              console.log(s);
             this.scheduleOptions.substitutes.push(s);
            });
          }
          this.substitute = { user_id: null, schedules: [] };
          this.cautionText = "";
          this.sDialog = false;
          this.snackbar = true;
          this.snackbarText = "Done";
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
          this.snackbarText = "Error: " + error.response.data.message;
        });
    },
    getContentId(schedule) {
      let ind = this.contents.findIndex((c) => {
        return (
          c.course_id == schedule.course_id &&
          c.section == schedule.section &&
          c.period == schedule.period
        );
      });
      return ind > -1 ? this.contents[ind].content_id : 0;
    },
    viewContent(schedule) {
      this.courseContents = [];
      this.$sisApi("get", "course-content/by-schedule", {
        course_id: schedule.course_id,
        section: schedule.section,
        period: schedule.period,
        date: this.scheduleDate,
      }).then((response) => {
        this.courseContents = response.data;
      });
      this.cDialog = true;
    },
  },

  mounted() {
    this.location_id = this.$store.state.u.location_id;
    this.$store.dispatch("getLocations");
    this.$store.dispatch("getStaffList");
    this.getMasterSchedule();
  },
};
</script>
